import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text" }

import { ref, computed } from 'vue'

import { usePreferencesStore } from '@/popup/store/PreferencesStore'
import Dropdown from '@/popup/components/shared/Dropdown/Dropdown.vue'
import DropdownItem from '@/popup/components/shared/Dropdown/DropdownItem.vue'
import { CurrencySymbol } from '@/popup/lib/currencies'


export default /*#__PURE__*/_defineComponent({
  __name: 'Currency',
  setup(__props) {

const preferencesStore = usePreferencesStore()
const currentCurrency = ref(preferencesStore.currentCurrency)
const dropdownOpened = ref(false)

const currencies = computed(() => {
  const currencies: string[] = []

  for (const currency of Object.keys(preferencesStore.currencies)) {
    currencies.push(currency)
  }

  return currencies.length > 0 ? currencies : [preferencesStore.currentCurrency]
})

const onChangeCurrency = async (currency?: CurrencySymbol) => {
  if (currency) {
    currentCurrency.value = currency
    await preferencesStore.setCurrentCurrency(currency)
    dropdownOpened.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Dropdown, {
    selected: currentCurrency.value!,
    "is-open-up": true
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencies.value, (currency, index) => {
        return (_openBlock(), _createBlock(DropdownItem, {
          key: index,
          "is-active": currentCurrency.value === currency,
          "data-testid": "currency-action",
          onClick: ($event: any) => (onChangeCurrency(currency))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(`settings.currency.option.${currency?.toLowerCase()}`)), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-active", "onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["selected"]))
}
}

})